import { render } from "./Declaration.vue?vue&type=template&id=8c1f4d5e&scoped=true&ts=true"
import script from "./Declaration.vue?vue&type=script&lang=ts"
export * from "./Declaration.vue?vue&type=script&lang=ts"

import "./Declaration.vue?vue&type=style&index=0&id=8c1f4d5e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c1f4d5e"]])

export default __exports__